import { render } from "./Printing.vue?vue&type=template&id=482e701b"
import script from "./Printing.vue?vue&type=script&lang=js"
export * from "./Printing.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src383431102/src/serverlesspressoV3/frontends/vue-barista-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__